import { AccountService } from './../../shared/services/account.service';
import * as moment from 'moment';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Observable, BehaviorSubject} from 'rxjs';
import {EditableAccountDTO, LoginService} from '../../shared';
import { NotificationType, EditableAccount } from './../../shared/model/account.model';

@Injectable()
export class Register {

      private newAccountSource: BehaviorSubject<EditableAccount> = new BehaviorSubject<EditableAccount>(new EditableAccount());

    constructor(private http: HttpClient,
        private router: Router,
        private loginService: LoginService,
        private accountService: AccountService) {
        }

    reset(): void {
        this.newAccountSource.next(new EditableAccount());
    }

    save(account: EditableAccountDTO): Observable<any> {
        account.birthDate = this.formatDate(account.birthDate);
        account.notification = NotificationType.EMAIL;
        return this.http.post('/api/register', account);
    }

    cancel() {
        const isFranceConnectUser = this.newAccountSource.getValue().credentials.franceConnectSubscription
            && !this.newAccountSource.getValue().id;
        this.reset();
        if (isFranceConnectUser) {
            this.loginService.fcLogout();
        } else {
            this.router.navigate(['/']);
        }
    }

    injectFCUser(account: EditableAccountDTO) {
        this.newAccountSource.next(this.accountService.mapAccoutToEditableAccount(account));
    }

    private formatDate(date): Date {
        return date ? moment(date).format('YYYY-MM-DD') : date;
    }

    newAccountAsObservable(): Observable<EditableAccount> {
        return this.newAccountSource.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.service.ts